<template>
  <div class="page-wrapper" style="padding-top: 0">
    <Form :label-width="80">
      <Row :gutter="16">
        <Col span="8">
          <FormItem label="房型名称: ">
            <span>{{houseTypeData.houseTypeName}}</span>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="价格: ">
            <span>{{houseTypeData.price}}</span>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="联系电话: ">
            <span>{{houseTypeData.projectPhone}}</span>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="8">
          <FormItem label="地址: ">
            <span>{{houseTypeData.projectAddress}}</span>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="经度: ">
            <span>{{houseTypeData.lng}}</span>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="纬度: ">
            <span>{{houseTypeData.lat}}</span>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="8">
          <FormItem label="房型简介: ">
            <span>{{houseTypeData.houseTypeIntroduction}}</span>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
  export default {
    name: "HouseTypeBaseInfo",
    props: {
      houseTypeData: {
        type: Object,
        default: null
      }
    },
    watch: {
    },

    data() {
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .item {
    display: inline-block;
    line-height: 1;
    margin-bottom: 25px;
    width: 30%;
    vertical-align: top;
    margin-right: 10px;
    min-width: 150px;

  }

  .item2 {
    margin-bottom: 20px;
    display: flex;

  }

  .left {
    display: inline-block;
  }

  .block {
    display: block;
  }

  h3 {
    margin: 10px 0 25px 0;
    font-size: 12px;
  }

  .m10 {
    margin: 10px 0;
  }
  .lable{
    flex-shrink: 0;
  }

  .item > span:nth-child(2) {
    font-weight: bold;
  }

  .item2 > span:nth-child(2) {
    font-weight: bold;
  }
  .flex{
    display: flex;
  }
  .vr_span{
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap !important;
  }

</style>
